import React from 'react'

import { goldKicker, kickerStyling } from './KickerComponent.module.css'

const KickerComponent = ({ children, extraClassName, faqSection, gold }) => {
  if (faqSection) {
    return (
      <h3
        className={`${kickerStyling} ${extraClassName} ${
          gold ? goldKicker : ''
        }`}
      >
        {children}
      </h3>
    )
  }

  return (
    <p
      className={`${kickerStyling} ${extraClassName}  ${
        gold ? goldKicker : ''
      }`}
    >
      {children}
    </p>
  )
}

export default KickerComponent
